// start:ng42.barrel
export * from './special-night-rate.model';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/special-night-rate/index.ts